import { useRef, useEffect } from 'react'

const useSharedRef = forwardedRef => {
  const ref = useRef()

  useEffect(() => {
    if (!forwardedRef) return

    switch (typeof forwardedRef) {
      case 'function':
        forwardedRef(ref.current)
        break
      case 'object':
        forwardedRef.current = ref.current
        break
    }
  }, [ forwardedRef ])

  return ref
}

export default useSharedRef
